var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIconActionSendToQuickBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93331 4.21331L10.5933 2.32665C13.1333 1.47998 14.5133 2.86665 13.6733 5.40665L11.7866 11.0666C10.52 14.8733 8.43997 14.8733 7.17331 11.0666L6.61331 9.38665L4.93331 8.82665C1.12664 7.55998 1.12664 5.48665 4.93331 4.21331Z",
    stroke: "#374957",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73999 9.1L9.12666 6.70667",
    stroke: "#374957",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconActionSendToQuickBooks);
export default __webpack_public_path__ + "static/media/table_icon_action_send_to_quick_books.afa4afc89b450227d940a545b1f8858f.svg";
export { ForwardRef as ReactComponent };